module.exports = __webpack_public_path__ + "static/media/wallfinishes_material_60y_n.b5306cfc.csv";